var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vod",
      style: _vm.$store.getters["customizer/getVodStyles"]
    },
    [
      _c(
        "div",
        { staticClass: "vod__home-button-wrapper" },
        [
          _c("BackButton", { attrs: { "is-active": _vm.getIsFocusOnBack } }, [
            _vm._v("\n      " + _vm._s(_vm.getBack) + "\n    ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "vod__salutation" }, [
        _c("span", { staticClass: "vod__text", style: _vm.getTextStyles }, [
          _vm._v("\n      VoD\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "vod__name" }, [
        _c("span", { staticClass: "vod__text", style: _vm.getTextStyles }, [
          _vm._v("\n      " + _vm._s(_vm.getCategoryName) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("Vod", {
        attrs: {
          menuItems: _vm.getMainMenu,
          "active-item-index": _vm.getActiveItemIndex,
          "is-active": _vm.getIsFocusOnNav
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f4a057", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f4a057","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Vod.vue
// module id = null
// module chunks = 